import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { HeroLeadForm } from './HeroLeadForm';
import { business } from '../data/site';
type Crumb = {
  label: string;
  to?: string;
};
type LandingHeroProps = {
  eyebrow: string;
  title: string;
  intro: string;
  crumbs?: Crumb[];
  offer?: {
    label: string;
    detail: string;
  };
  defaultService?: string;
  sourcePage: string;
};
export function LandingHero({
  eyebrow,
  title,
  intro,
  crumbs,
  offer,
  defaultService,
  sourcePage
}: LandingHeroProps) {
  return <section className="w-full bg-ink py-12 text-white lg:py-16" data-id="element-253" data-mp="tgs648bh8jtm">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-254" data-mp="tilati2j4tyz">
        <div className="grid grid-cols-[minmax(0,1fr)] gap-y-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,400px)] lg:items-start lg:gap-x-14 lg:gap-y-0" data-id="element-255" data-mp="yf20whtahiep">
          <div className="order-1 min-w-0 lg:col-start-1 lg:row-start-1" data-id="element-256" data-mp="ki6oqghqrauf">
            {crumbs && crumbs.length > 0 && <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-[13px] text-chalk/55" data-id="element-257" data-mp="20psiglpbwk92">
                {crumbs.map((crumb, i) => <React.Fragment key={crumb.label} data-id="element-258" data-mp="2aoi3gnciuktj" data-mpi={i}>
                    {i > 0 && <ChevronRightIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-259" data-mp="25ovni65b6qh1" />}
                    {crumb.to ? <Link to={crumb.to} className="hover:text-white" data-id="element-260" data-mp="1d0zjegdetwa8">
                        {crumb.label}
                      </Link> : <span className="text-white" data-id="element-261" data-mp="1rqxg5kpenub1">{crumb.label}</span>}
                  </React.Fragment>)}
              </nav>}

            <p className="mt-5 flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-brand-light" data-id="element-262" data-mp="z6yvkhnzxton">
              <MapPinIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-263" data-mp="1jxubj6p17i0v" />
              {eyebrow}
            </p>

            <h1 className="mt-4 max-w-[720px] font-display text-[31px] font-extrabold leading-[1.06] tracking-[-0.02em] sm:text-[42px] lg:text-[46px]" data-id="element-264" data-mp="1nz7f1a4nj94m">
              {title}
            </h1>
          </div>

          <div className="order-2 min-w-0 lg:order-none lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-265" data-mp="1xpscuvci49mh">
            <HeroLeadForm defaultService={defaultService} sourcePage={sourcePage} data-id="element-266" data-mp="10zrsd8j60faz" />
          </div>

          <div className="order-3 min-w-0 lg:col-start-1 lg:row-start-2 lg:mt-5" data-id="element-267" data-mp="150v87v17qbc7">
            <p className="max-w-[600px] text-[17px] leading-relaxed text-chalk/75" data-id="element-268" data-mp="19ywrafyn2ano">
              {intro}
            </p>

            {offer && <div className="mt-6 rounded-lg border border-brand/40 bg-charcoal px-5 py-4" data-id="element-269" data-mp="2letpyvwa48y3">
                <p className="font-display text-[18px] font-bold tracking-tight text-brand-light" data-id="element-270" data-mp="2qdxz5mj7e6of">
                  {offer.label}
                </p>
                <p className="mt-1 text-[14px] leading-relaxed text-chalk/70" data-id="element-271" data-mp="ep9mcm8c9uza">
                  {offer.detail}
                </p>
              </div>}

            <a href={business.phoneHref} className="mt-7 inline-flex max-w-full items-center justify-center gap-3 rounded-md bg-brand px-6 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light sm:px-7" data-id="element-272" data-mp="50hvkhf0lgpy">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-273" data-mp="3n6o0izka75if" />
              Call {business.phone}
            </a>

            <p className="mt-4 text-[13.5px] text-chalk/55" data-id="element-274" data-mp="3i8cmsdqv8aux">
              Monday – Friday, 8:00 AM – 5:00 PM · {business.address.street},{' '}
              {business.address.city}, {business.address.state}
            </p>
          </div>
        </div>
      </div>
    </section>;
}